// extracted by mini-css-extract-plugin
export default {"tabs":"tabs__-4431a4b","tab":"tab__-4431a4b","active":"active__-4431a4b"};